import {Outlet} from 'react-router-dom'

interface LinkProps {
	path: string
	label: string
}

function MenuLink(props: LinkProps) {
	return (
		<a
			className="p-4 hover:bg-sky-200 hover:cursor-pointer"
			href={props.path}
		>
			{props.label}
		</a>
	)
}

function Spacer() {
	return <div className="h-1 pb-3 border-t border-sky-200"></div>
}

export default function BackOffice() {
	return (
		<div className="flex h-screen">
			<div className="w-1/4 border-r-2 border-sky-700">
				<div className="flex flex-col">
					<h2 className="mb-3 pb-3 pt-4 border-b-2 border-sky-500 text-lg text-center">Back Office Dev</h2>
					<MenuLink path="/" label="Home"/>
					<Spacer/>
					<MenuLink path="/back-office/marketplace" label="ProtectPlus"/>
					<MenuLink path="/back-office/hold-sale" label="Hold Sale"/>
					<MenuLink path="/back-office/patch-sale" label="Patch Sale"/>
					<MenuLink path="/back-office/cancel-sale" label="Cancel Sale"/>
				</div>
			</div>
			<div className="w-3/4">
				<Outlet/>
			</div>
		</div>
	)
}
